module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.criteriosClassificacao.novoCriterio'),
      "subTitle": _vm.$t('planoConciliacao.titulos.criteriosClassificacao.novoCriterioInfo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('planoConciliacao.titulos.criteriosClassificacao.novoCriterioPortlet')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criteria.criterioEmUso),
      expression: "criteria.criterioEmUso"
    }],
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon alert-icon"
  }), _c('span', {
    staticClass: "alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.validacao.criterioEmUsoEditar'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.detalheCriterio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "criteriaCategory"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.associacaoCategoria'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    key: "criteriaCategory",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('criteria.categoria')
    },
    attrs: {
      "options": _vm.categories,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "criteria.categoria",
      "id": "criteriaCategory",
      "name": "criteriaCategory",
      "disabled": _vm.criteria.criterioEmUso
    },
    on: {
      "input": _vm.setValuesFieldsCategory
    },
    model: {
      value: (_vm.criteria.categoria),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "categoria", $$v)
      },
      expression: "criteria.categoria"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('criteria.categoria', 'required')),
      expression: "errors.firstByRule('criteria.categoria', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critDesc"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricaoCriterio'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.descricao),
      expression: "criteria.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critDesc",
      "name": "critDesc",
      "data-vv-name": "criteria.descricao",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.criteria.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('criteria.descricao', 'required')),
      expression: "errors.firstByRule('criteria.descricao', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.ativo),
      expression: "criteria.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "active"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.criteria.ativo, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "ativo", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "active"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.ativo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.ativo),
      expression: "criteria.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.criteria.ativo, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "ativo", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.inativo'))
    }
  })]), _c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevancia'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.relevante),
      expression: "criteria.relevante"
    }],
    attrs: {
      "type": "radio",
      "name": "relevancia",
      "id": "relevante",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.criteria.relevante, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "relevante", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "relevante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevante'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.relevante),
      expression: "criteria.relevante"
    }],
    attrs: {
      "type": "radio",
      "name": "relevancia",
      "id": "irrelevante",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.criteria.relevante, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "relevante", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "irrelevante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.irrelevante'))
    }
  }), _c('br')])])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.aplicarCriterio'))
    }
  }), _c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critHist"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.mascaraHistorico'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.historico),
      expression: "criteria.historico"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critHist",
      "name": "critHist",
      "maxlength": "250",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": (_vm.criteria.historico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "historico", $event.target.value)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critCompl"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.mascaraComplemento'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.complemento),
      expression: "criteria.complemento"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critCompl",
      "name": "critCompl",
      "maxlength": "50",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": (_vm.criteria.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "complemento", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critCodHist"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.codigoHistorico'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.codigoHistorico),
      expression: "criteria.codigoHistorico"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critCodHist",
      "name": "critCodHist",
      "maxlength": "4",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": (_vm.criteria.codigoHistorico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "codigoHistorico", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critFebraban"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.febraban'))
    }
  }), _c('v-select', {
    key: "critFebraban",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.febraban,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "criteria.categoriaFebraban",
      "id": "critFebraban",
      "name": "critFebraban",
      "disabled": _vm.criteria.criterioEmUso
    },
    model: {
      value: (_vm.criteria.categoriaFebraban),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "categoriaFebraban", $$v)
      },
      expression: "criteria.categoriaFebraban"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critBank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.banco'))
    }
  }), _c('v-select', {
    key: "critBank",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.banks,
      "id": "critBank",
      "name": "critBank",
      "data-vv-name": "criteria.banco",
      "disabled": _vm.criteria.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    on: {
      "input": _vm.filterAccounts
    },
    model: {
      value: (_vm.criteria.banco),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "banco", $$v)
      },
      expression: "criteria.banco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critAccount"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conta'))
    }
  }), _c('v-select', {
    key: "critAccount",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.filteredAccounts,
      "id": "critAccount",
      "name": "critAccount",
      "data-vv-name": "criteria.conta",
      "disabled": _vm.criteria.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    model: {
      value: (_vm.criteria.conta),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "conta", $$v)
      },
      expression: "criteria.conta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('br')], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.chaveRelacionamento'))
    }
  }), _c('button-primary', {
    staticClass: "marged-button",
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.adicionar'),
      "faIcon": "fa fa-plus",
      "id": "btnAddCampoClassificacao",
      "clickFunction": _vm.addClassificationField,
      "disabled": _vm.criteria.criterioEmUso
    }
  }), _c('br'), _vm._l((_vm.criteria.classificacaoCampos), function(field) {
    return _c('div', [_c('conciliation-field', {
      key: field.key != undefined && field.key != null ? field.key : field.id,
      ref: field.key != undefined && field.key != null ? field.key : field.id,
      refInFor: true,
      attrs: {
        "conciliationField": field,
        "attributesCfg": _vm.attributesCfg,
        "attributes": field.idAtributoCfg != null && field.idAtributoCfg.children ? field.idAtributoCfg.children : [],
        "conciliationFields": _vm.conciliationFields,
        "disabled": _vm.criteria.criterioEmUso
      },
      on: {
        "remove-field-from-criteria": _vm.removeClassificationField,
        "change-conc-field-cfg": _vm.changeFieldAttCfg,
        "change-conc-field-att-name": _vm.changeFieldAttName,
        "change-conc-field": _vm.changeFieldAttConciliationField
      }
    })], 1)
  })], 2)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.adicionar'),
      "id": "btnAddCriterioClassificacao",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.voltar'),
      "id": "btnRetornaEdicaoPlano",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72a54622", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a54622"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/classificationCriteria/newClassificationCriteria.pug
// module id = 1433
// module chunks = 0